import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';
import $ from 'jquery';
import { Button } from 'antd';
import AceEditor from 'react-ace';
import { DraggableModal, DraggableModalContext, DraggableModalProvider } from 'ant-design-draggable-modal';
import 'antd/dist/antd.css';
import 'ant-design-draggable-modal/dist/index.css';
import ModalsService from 'services/ModalsService';
import LoadingSpinner from 'components/core/LoadingSpinner';

/**
 * Renders a modal image gallery for plots generated for one data consolidator run.
 */
export default class DataConsolidatorLogViewer extends React.Component {
    static propTypes = {
        onClose: PropTypes.func,          // close handler
        processName: PropTypes.string,
        baseUrl: PropTypes.string,
        title: PropTypes.string,          // dialog title
        route: PropTypes.string,          // web service route
        runDate: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.state = {
            logFileContents: null,
        };
    }

    componentDidMount() {
        if (!this.state.logFileContents) {
            this.fetchTextFile();
        }
    }

    fetchTextFile = () => {
        const runDate = this.props.runDate;
        const route = this.props.route;
        const title = this.props.title;
        const baseUrl = this.props.baseUrl;
        const processName = this.props.processName;

        const sessionId = localStorage.getItem('sessionId');
        // http://pcm-server.local/app_dev.php/processes/queezie1/getlog/2020-05-19_11:44:23.045689?session_id=nj590c48r938abhbvhfg0m1mq0
        const url = `${baseUrl}/processes/${processName}/${route}/${runDate}?session_id=${sessionId}`;
        const instance = this;
        $.ajax({
            url
        }).done((data, textStatus, jqXHR) => { // request was sucessful
            instance.setState({
                logFileContents: data
            });

        }).fail((jqXHR, textStatus, errorThrown) => {
            ModalsService.openModal({
                id: 'logfile_failed',
                modalType: ModalsService.TYPE_ERROR,
                modalTitle: 'Failed to Retrieve File',
                modalMessage: errorThrown
            });
        });
    };

    render() {
        const modalStyle = css`
            .ant-modal-content {
                max-width: calc(100vw);
            }
            .ant-modal-body {
                padding: 12px;
            }
        `;

        let component;
        if (!this.state.logFileContents) {
            component = <LoadingSpinner/>;

        } else {
            component = (
                <AceEditor
                    mode="text"
                    theme="github"
                    editorProps={{ $blockScrolling: 'Infinity' }}
                    width="100%"
                    height="100%"
                    cursorStart={1}
                    fontSize="14"
                    showPrintMargin
                    showGutter
                    highlightActiveLine
                    focus
                    value={this.state.logFileContents}
                />
            );
        }

        return (
            <DraggableModalProvider>
                <DraggableModal
                    zIndex={1002}
                    className={modalStyle}
                    title={this.props.title}
                    visible
                    onOk={this.props.onClose}
                    onCancel={this.props.onClose}
                    footer={[
                        <Button key="close" onClick={this.props.onClose}>Close</Button>
                    ]}
                >
                    {component}
                </DraggableModal>
            </DraggableModalProvider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/DataConsolidatorLogViewer.js